export const en = {
    EngagementMetricPicker: {
        ariaLabel: "Metric: {{label}}"
    },
    MetricTrendChart: {
        title: "{{metric}} over time",
        legend: {
            yourTeam: "Your team",
            company: "Company"
        },
        delta_one: "{{sign}}{{value}} pt",
        delta_other: "{{sign}}{{value}} pts",
        deltaZero: "No change",
        yAxisLabel: "Score",
        ariaLabel: "{{metric}} score over the {{period}}."
    },
    SubMetricsList: {
        eyebrow: "Sub-metrics",
        tooltipLabel: "About {{subMetric}}",
        delta_one: "{{sign}}{{value}} pt",
        delta_other: "{{sign}}{{value}} pts",
        deltaZero: "No change"
    },
    QuestionsDistributionTable: {
        title: "{{metric}} questions",
        caption: "Pulse questions in the {{metric}} driver, with the team's response distribution.",
        columns: {
            subMetric: "Submetric",
            question: "Question",
            results: "Results"
        },
        band: {
            stronglyAgree: "Strongly agree",
            agree: "Agree",
            neutral: "Neutral",
            disagree: "Disagree",
            stronglyDisagree: "Strongly disagree"
        },
        inactive: "Inactive",
        noResponses: "Not enough responses yet",
        writtenResponses_one: "{{count}} written response",
        writtenResponses_other: "{{count}} written responses",
        partialSample: "Results based on partial sample",
        extensiveSample: "Results based on an extensive sample",
        resultsAriaLabel: 'Results for "{{question}}": Strongly agree {{stronglyAgree}}%, Agree {{agree}}%, Neutral {{neutral}}%, Disagree {{disagree}}%, Strongly disagree {{stronglyDisagree}}%.',
        pagination: {
            ariaLabel: "Question results pagination",
            showing: "Showing {{from}}–{{to}} of {{total}}",
            pageOf: "{{page}} / {{totalPages}}",
            previous: "Previous page",
            next: "Next page"
        },
        liveRegion: {
            sortChanged: "Sorted by {{column}} {{direction}}",
            ascending: "ascending",
            descending: "descending",
            columns: {
                subMetric: "Submetric",
                question: "Question",
                results: "Results"
            }
        }
    },
    EngagementSparkline: {
        sectionLabel: "Last {{period}}",
        sectionLabelQuarter: "This quarter",
        sectionLabelYear: "This year",
        sectionLabelAllTime: "All time",
        dataStart: "No data before {{date}}",
        yAxisLabel: "Engagement",
        ariaLabel: "Engagement score sparkline over {{period}}"
    },
    EnpsGauge: {
        bandLabel: {
            "needs-work": "Needs work",
            neutral: "Neutral",
            good: "Good",
            excellent: "Excellent"
        },
        bandSentence: {
            "needs-work": "Detractors outnumber promoters. Focus on addressing blockers surfaced in feedback.",
            neutral: "Roughly even split. Small actions move the needle at this level.",
            good: "Healthy advocacy. Most people would recommend working here.",
            excellent: "Strong advocacy at a level most companies never reach."
        },
        offBadge: "Off since {{month}}",
        offBadgeDateless: "Surveys off",
        scoreAriaLabel: "Employee NPS {{value}}, {{band}}",
        noData: "Employee NPS score: no data yet",
        notEnoughResponses: "Not enough responses",
        scoreNotAvailableAriaLabel: "Employee NPS score not available: not enough responses"
    },
    EnpsTrendChart: {
        sectionLabel: "Last {{period}}",
        sectionLabelQuarter: "This quarter",
        sectionLabelYear: "This year",
        sectionLabelAllTime: "All time",
        dataStart: "No data before {{date}}",
        surveysOff: "Surveys turned off",
        surveysOffSince: "eNPS surveys off since {{date}}",
        yAxisLabel: "eNPS score",
        ariaLabel: "Employee NPS trend over {{period}}"
    },
    EnpsDistributionChart: {
        title: "Distribution",
        chartLabel: "Distribution over time · {{period}}",
        legend: {
            promoters: "Promoters",
            passives: "Passives",
            detractors: "Detractors"
        },
        surveysOff: "Surveys turned off",
        surveysOffSince: "eNPS surveys off since {{date}}",
        ariaLabel: "Employee NPS distribution over {{period}}"
    },
    EnableEnpsDialog: {
        enableCta: "Enable eNPS surveys",
        eyebrow: "Heads up",
        title: "One quick detour",
        body: "eNPS is turned on and off in the classic Workleap app. We'll take you there to turn it back on.",
        cancel: "Cancel",
        continue: "Continue in Officevibe",
        opensInNewTab: "Opens in a new tab"
    }
};
